import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueFormClientsController', IssueFormClientsController);

    function IssueFormClientsController(CompanyFactory, CompaniesFactory) {
        var vm = this,
            paramList = { page_size: 1000 };

        CompanyFactory.readCompany().then(function (response) {
            CompaniesFactory.readHousingAssociations(
                response.data.organization.party_uuid,
                paramList
            ).then(function (housingResponse) {
                vm.dataFromBackend = housingResponse.data.results;
            });
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/clients/issue_form_clients.controller.ts